import { ACTIONS } from '../types';
import STATUS from '../../../globalStatuses';

export const degreeTypeReductions = {
  [ACTIONS.REQUEST_DEGREETYPE]: state => ({
    ...state,
    degreeTypesStatus: {
      ...state.degreeTypesStatus,
      getStatus: STATUS.FETCHING,
      errorData: null,
    },
  }),
  [ACTIONS.RECEIVE_DEGREETYPE]: (state, action) => ({
    ...state,
    degreeTypes: action.payload.degreeTypes,
    degreeTypesStatus: {
      ...state.degreeTypesStatus,
      getStatus: STATUS.FETCHED,
    },
  }),
  [ACTIONS.RECEIVE_DEGREETYPE_ERROR]: (state, action) => ({
    ...state,
    error: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
    degreeTypesStatus: {
      ...state.degreeTypesStatus,
      getStatus: STATUS.ERROR,
      errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
    },
  }),
};

export default degreeTypeReductions;
